// extracted by mini-css-extract-plugin
module.exports = {"deleteConfirmModal":"deleteConfirmModal_deleteConfirmModal__2WnHg","content":"deleteConfirmModal_content__2QDCw","buttonSection":"deleteConfirmModal_buttonSection__3_8K5"};